import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import ReactRouterPropTypes from 'react-router-prop-types'
import { withRouter } from 'react-router-dom'
import { FormattedMessage, injectIntl } from 'react-intl'
import useGetStock from 'core/hooks/useGetStock'
import * as routes from 'core/routing/constants/index'
import MainContentWrapper from 'core/templates/MainContentWrapper'
import styled from 'styled-components'
import { ButtonPrev, Row, Col, List } from 'core/components/ui'

import wizardsShape from 'core/components/wizard/shapes'
import { greys } from 'assets/themes/theme-default'
import { stockShape } from '../shapes'

import VehicleItem from './vehicle-item'
import Filters from './filters'

const BackToHomeWrapper = styled.div`
  margin-bottom: 20px;
`

const FiltersWrapper = styled(Col)`
  padding: 20px;
  background: ${greys.light4};
`

const VehiclesList = props => {
  const { history, intl, wizards, setStock, stock } = props

  const {
    loadingVehicles,

    vehicles,
    setFilters,
    filters,
    getFiltersDatas,
    setFiltersDatas,
    filtersDatas,
    loadingFiltersDatas
  } = useGetStock({
    redirectMessage: intl.formatMessage({ id: 'ui-session-expired' })
  })

  const { vehiclesList, filtersList, filtersValues } = stock

  const reinInitFilters = () => {
    const extendedStock = {
      ...stock,
      filtersValues: {}
    }
    setStock(extendedStock)
  }

  const onChangeFilter = val => {
    setFilters(val)
  }

  useEffect(() => {
    const runIt = list => {
      const extendedStock = {
        ...stock,
        filtersValues: list
      }

      setStock(extendedStock)
    }

    if (filters) runIt(filters)
  }, [filters])

  useEffect(() => {
    const runIt = list => {
      setStock({
        ...stock,
        vehiclesList: list
      })
    }
    if (vehicles) runIt(vehicles)
  }, [vehicles])

  useEffect(() => {
    const runIt = values => {
      setFilters(values)
    }
    if (filtersValues) runIt(filtersValues)
  }, [filtersValues])

  useEffect(() => {
    const runIt = list => {
      const extendedFiltersList = {
        ...filtersList,
        ...list
      }

      const extendedStock = {
        ...stock,
        filtersList: extendedFiltersList
      }

      setStock(extendedStock)
    }
    if (filtersDatas) runIt(filtersDatas)
  }, [filtersDatas])

  useEffect(() => {
    const aStepsActive = wizards[wizards.activeWizard]

    const extendedStepsActive = aStepsActive.filter(
      step => step.hash === routes.STOCK_VEHICLES_LIST
    )
    const currentStep = extendedStepsActive[0]

    const { isActive } = currentStep

    if (!isActive) {
      history.push(routes.HOME)
    }

    setStock({
      ...stock,
      vehiclesList: [],
      selectedVehicle: null
    })
    //setFilters(filtersValues)
    setFiltersDatas(filtersList)
    getFiltersDatas(filtersList)
  }, [])

  return (
    <MainContentWrapper title={intl.formatMessage({ id: 'stock-vehicles-list-view-title' })}>
      <BackToHomeWrapper>
        <ButtonPrev onClick={() => history.push(routes.HOME)}>
          <FormattedMessage id="ui-button-back" />
        </ButtonPrev>
      </BackToHomeWrapper>
      <Row gutter={30}>
        <Col span={6}>
          <FiltersWrapper>
            {filters && filtersDatas && (
              <Filters
                reinInitFilters={reinInitFilters}
                loading={loadingFiltersDatas}
                filtersDatas={filtersDatas}
                filters={filters}
                onChangeFilter={onChangeFilter}
              />
            )}
          </FiltersWrapper>
        </Col>
        <Col span={18}>
          {vehiclesList && (
            <List
              className="globaldealer-flex-row"
              grid={{ gutter: 16, column: 3 }}
              dataSource={vehiclesList}
              loading={loadingVehicles}
              renderItem={item => (
                <List.Item>
                  <VehicleItem vehicle={item} />
                </List.Item>
              )}
            />
          )}
        </Col>
      </Row>
    </MainContentWrapper>
  )
}

VehiclesList.propTypes = {
  history: ReactRouterPropTypes.history.isRequired,
  intl: PropTypes.shape().isRequired,
  /* setWizards: PropTypes.func.isRequired,*/
  wizards: wizardsShape.isRequired,
  stock: stockShape.isRequired,
  setStock: PropTypes.func.isRequired
}

export default withRouter(injectIntl(VehiclesList))
